/* file description */
import { editModuleRecordList } from './assetModel';
import { message } from 'antd';
import { TIP_MSG_MAP } from '@/components/SPTableWithModel/effect/consts';

function recursiveObj(obj) {
  for (const k in obj) {
    if (obj.hasOwnProperty(k)) {
      if (typeof obj[k] === 'object') {
        recursiveObj(obj[k]);
      } else {
        // console.log(`${k}:${obj[k]}`)
        if (obj[k] === undefined) {
          obj[k] = null;
        }
      }
    }
  }
}

function toJSON(params: any) {
  const res: any[] = [];
  Object.keys(params).filter(key => key !== 'toJSON').forEach(key => {
    let value = params[key];
    if (_.isObject(value)) {
      value = value;
    } else if (value !== undefined && value !== null) {
      value = String(value);
    }
    res.push({
      name: key,
      value,
    });
  });
  return res;
}

export const updataAssetModuleByRequest = async (FetchAPI: any, params: any) => {
  // console.log('params.record', params.record)
  // const recordIns = new compose.Record(params.moduleInfo, params.record);
  // recursiveObj(params.record);
  const info = {
    // values: (recordIns.values as any).toJSON(),
    values: toJSON(params.record),
    records: [],
    labels: '{}',
    click: 'save',
    // ...params
  };

  try {
    const res = await editModuleRecordList(FetchAPI, params.namespaceID, params.moduleID, params.recordKey, info);
    if (res) {
      message.success(TIP_MSG_MAP.autoLineEditUpdateSuccess);
    }
    return res;
  } catch (e) {
    message.error(TIP_MSG_MAP.autoLineEditUpdateError);
    return {};
  }

  // return new compose.Module(res);
};
